__webpack_require__.p = "/reports-dashboard-templates-sidebar/referrals-hub/";